module.exports = __webpack_public_path__ + "media/images/sprites/yellow-ab395a0a1b3f7d5f44acceb2dd283a6d.png";